export default "__VITE_ASSET__D13jnnUE__"